import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/workLocationActions';

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";

const CommentModal = ({
  workLocation,
  currentDepartment,
  workLocationType,
  showComments,
  modalSaving,
  userPermissions,
  currentLeave,
  saveWorkLocation,
  // mySaveLeave
}) => {

  const [comment, setComment] = useState();

  if (!workLocation) {
    return null;
  }

  const saveWorkLocationData = () => {

    const workLocationData = {
      id: workLocation.id,
      comment: comment,
      agreement: workLocation.agreementID || workLocation.agreementId,
    }

    saveWorkLocation(workLocationData);
    showComments(null);
    setComment(null)
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { showComments(null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Comments for Work Location Application {format(new Date(workLocation.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content">

              {
                workLocation.comments.map(comment => (
                  <div>
                    <span style={{
                      fontWeight: "bold"
                    }}>{comment?.byName || ''}</span>
                    <span style={{
                      fontSize: "12px"
                    }}> - {format(new Date(comment.createdAt || workLocation.date), "do MMM yyyy HH:mm")}</span>
                    <p>{comment?.comment || comment}</p>

                  </div>
                ))
              }

              {userPermissions != 'Read' &&
                <div className="form-group" >
                  <div className="col-sm-12" style={{ padding: 0 }}>
                    <label>Add Comment</label>
                    <textarea
                      className="form-control"
                      type="text"
                      name="comment"
                      style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                      onChange={(e) => {
                        setComment(e.target.value)
                      }}
                    >{comment}</textarea>
                    <div className="clearfix" />
                  </div>
                  <div className="clearfix" />
                </div>
              }

              {comment &&
                <button className="btn btn-success pull-right" onClick={() => saveWorkLocationData()} style={{ marginRight: 0, marginBottom: "20px" }}>Save Comment</button>
              }

              {!comment &&
                <button className="btn btn-default pull-right" onClick={() => { showComments(null) }} style={{ marginRight: 0, marginBottom: "20px" }}>Close</button>
              }

              {
                modalSaving &&
                <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                  <Spinner
                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                  />
                  <div style={{ float: 'left' }}>Saving</div>
                </button>
              }
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {


  const {
    // workLocation,
    workLocationTypes,
  } = state.workLocation


  const workLocation = state.workLocation.showComments;
  const userPermissions = state?.permissions?.my?.permissions?.workLocations

  return {
    modalSaving: state.workLocation.modalSaving,
    workLocation,
    workLocationType: workLocationTypes && workLocation && _.find(workLocationTypes, { id: workLocation.type }).name,
    userPermissions,
  }
}

const mapDispatchToProps = dispatch => ({
  showComments: (workLocation) => dispatch(ACTIONS.showComments(workLocation)),
  saveWorkLocation: (workLocation) => dispatch(ACTIONS.saveWorkLocation(workLocation)),
  // mySaveLeave: (timesheet) => dispatch(MYACTIONS.mySaveLeave(timesheet)),
  // timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentModal) 
